import React from 'react';
import {
  MenuBar,
  MenuDropDown,
  MenuDropDownItem,
  MenuItem,
} from '../components';
import styles from './MainTemplate.module.css';
import cn from 'classnames';
import useAuthorization from '../hooks/useAuthorization';
import Spinner from '../components/atoms/Spinner/Spinner';
import { useNavigate } from 'react-router-dom';

const MainTemplate: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  // const { isAuthorized: isRegisteredUser, status: registeredUserStatus } =
  //   useAuthorization({ requiredRoles: ['RegisteredUser'] });

  const { isAuthorized: isAdmin, status: adminStatus } = useAuthorization({
    requiredRoles: ['Admin'],
  });

  const { isAuthorized: isCompactOwner, status: compactOwnerStatus } =
    useAuthorization({
      requiredRoles: ['LandscapeInitiativeManager'],
    });

  const { isAuthorized: isBuyerManager, status: buyerManagerStatus } =
    useAuthorization({
      requiredRoles: ['BuyerManager'],
    });

  const navigate = useNavigate();

  if (
    // registeredUserStatus === 'loading' ||
    // registeredUserStatus === 'idle' ||
    adminStatus === 'loading' ||
    adminStatus === 'idle' ||
    compactOwnerStatus === 'loading' ||
    compactOwnerStatus === 'idle' ||
    buyerManagerStatus === 'loading' ||
    buyerManagerStatus === 'idle'
  ) {
    return <Spinner />;
  }

  return (
    <div className={cn(styles.mainTemplateWrapper)}>
      <MenuBar
        onSelect={(to) => {
          navigate(`/${to}`);
        }}
      >
        {isAdmin && (
          <>
            <MenuItem to="landscapes" title="Landscapes" />
            {/* <MenuDropDown title="Landscapes">
              <MenuDropDownItem to="landscapes/types" title="Landscape Types" />
            </MenuDropDown> */}
            <MenuItem title="Organizations" to="organizations" />
            <MenuItem to="commodities" title="Commodities" />
            <MenuDropDown title="Progress Reporting">
              <MenuDropDownItem to="reporting-details/goals" title="Goals" />
              <MenuDropDownItem
                to="reporting-details/indicators"
                title="Indicators"
              />
              <MenuDropDownItem to="reporting-details/themes" title="Themes" />
              <MenuDropDownItem
                to="reporting-details/collections"
                title="Collections"
              />
              <MenuDropDownItem
                to="reporting-details/verification-statuses"
                title="Verification"
              />
            </MenuDropDown>
            <MenuDropDown title="User Management">
              <MenuItem to="user-management/users" title="Users" />
              {/* <MenuItem
                to="user-management/reports/newsletters"
                title="Reports"
              /> */}
              <MenuItem
                to="user-management/eventLogging"
                title="Event Logging"
              />
            </MenuDropDown>
            {/* <MenuDropDown title="Impact stories & Platform updates">
              <MenuDropDownItem
                title="Impact Stories"
                to="impact-stories&platform-updates/impact-stories"
              />
            </MenuDropDown> */}
          </>
        )}
        {isCompactOwner && !isAdmin && (
          <MenuItem to="landscapes" title="Landscapes" />
        )}
        {isBuyerManager && !isAdmin && (
          <MenuDropDown title="Organizations">
            <MenuDropDownItem title="Buyers" to="organizations" />
          </MenuDropDown>
        )}
      </MenuBar>
      <main>{children}</main>
    </div>
  );
};

export default MainTemplate;
